import { StaticLotData } from '../schema.design';
import Lot from '..';
import { Article } from '../types';
export const ArticleSwitch = ({
  article,
  lotData,
}: {
  article: Article;
  lotData: StaticLotData;
}) => {
  switch (article?.__typename) {
    case 'LotKeySpecs':
      const populatedSpecs = article.specsCollection.items

      return populatedSpecs.length >= 3 ? (
        <Lot.Specs
          gridArea={article.__typename}
          title={article.title}
          items={populatedSpecs.slice(0, 9)}
          customProperties={{}}
        />
      ) : null
    case 'LotOverview':
      return <Lot.Overview title={article.label} items={article.lotPropertiesCollection.items} data={lotData} />
    case 'LotAppointments':
      const items = lotData.appointments || []
      return (
        <Lot.Appointments
          gridArea={article.__typename}
          title={article.title}
          labels={{
            modalButtonTextNoUpcoming: article.modalButtonTextNoUpcoming,
            modalButtonText: article.modalButtonText,
          }}
          collectionDescription={article.collectionDescription?.json || null}
          inspectionDescription={article.inspectionDescription?.json || null}
          items={items}
          location={lotData.location}
          lotData={lotData}
        />
      )
    case 'LotAttachments':
      const lotAttachments = lotData.attachments || []
      const articleAttachments = article.attachmentsCollection.items || []
      const allAttachmentItems = [...articleAttachments, ...lotAttachments]
      return (
        <Lot.Attachments
          gridArea={article.__typename}
          title={article.title}
          items={allAttachmentItems}
          icons={article.iconsCollection.items}
        />
      )
    case 'LotAddedServices':
      return <Lot.AddedServices title={article.title} items={article.servicesCollection.items} />
    case 'LotVideos':
      const lotvideos = lotData.gallery.videos || []
      const articleVideos = article.linksCollection.items || []
      const allItems = [...articleVideos, ...lotvideos]
      return <Lot.Videos gridArea={article.__typename} title={article.title} items={allItems} />
    case 'LotSalesSupport':
      const contactTitle = article.contactTitle,
        email = article.email,
        phone = article.phone

      return (
        <Lot.SalesSupport
          title={article.title}
          contactTitle={contactTitle}
          phone={phone}
          email={email}
          icon={article.icon}
        />
      )
  }
  return null;
};
